import { Typography, Box, IconButton, Divider } from '@mui/material';
import Colors from 'constants/colors';
import React from 'react';
interface DetailItemTypes {
    label?: string;
    value?: string | number;
    textAlign?: string;
    fontWeight?: string | number;
    icon?: React.ReactNode;
    backgroundColor?: string;
    children?: React.ReactNode;
    handelIconButtonClick?: () => void;
    disabledIcon?: boolean;
}

// eslint-disable-next-line react/prop-types
const ProfileItemDetail: React.FC<DetailItemTypes> = ({
    icon,
    disabledIcon,
    label,
    value,
    children,
    fontWeight,
    backgroundColor,
    handelIconButtonClick,
}) => (
    <Box>
        <Box
            display={'flex'}
            height={60}
            justifyContent={'space-between'}
            borderRadius={2}
            sx={{ p: 1, mt: 2, mb: 2, backgroundColor: backgroundColor }}
        >
            <Typography sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                    sx={{
                        color: Colors.darkTextColor,
                        fontSize: { xs: 12, sm: 16 },
                        fontWeight: fontWeight || '400',
                    }}
                >
                    {label && `${label}`}
                </Typography>
                <Typography
                    sx={{
                        color: Colors.lightGrayTextColor,
                        fontSize: { xs: 10, sm: 14 },
                    }}
                >
                    {value}
                </Typography>
                {children}
            </Typography>

            {icon && (
                <IconButton disabled={disabledIcon} onClick={handelIconButtonClick} sx={{ color: 'black', width: '40px', height: '40px' }}>
                    {icon}
                </IconButton>
            )}
        </Box>
        <Divider />
    </Box>
);

export default ProfileItemDetail;
